import { Component } from "react";
import { Field } from "redux-form";
import { IProps } from "./types";
import TextInput from "../Form/TextInput";
import { StripeCardNumberElementOptions } from "@stripe/stripe-js";
import { CardExpiryElement, CardNumberElement, CardCvcElement } from "@stripe/react-stripe-js";
import StripeFee from "./StripeFee";

interface IState {
    cardBrand: any;
}

export class CreditCardForm extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = { cardBrand: "unknown" };
    }

    consentRequired = (value) => (value ? undefined : "Please check this field to add your card.");

    componentWillUnmount() {
        this.props.onWillUnmount();
    }

    setCardBrand = (e) => {
        this.setState({ cardBrand: e.brand });
    };

    render() {
        const options: StripeCardNumberElementOptions = {
            placeholder: "**** **** **** ****",
        };

        const consentErrorRules = [];
        if (this.props.isConsentRequired) {
            consentErrorRules.push(this.consentRequired);
        }

        return (
            <>
                {this.props.errorMessage && (
                    <div className="form-group row mb-2">
                        <div className="col-12">
                            <div className="alert alert-danger">{this.props.errorMessage}</div>
                        </div>
                    </div>
                )}
                <div className="form-group row mb-2">
                    <div className="col-12">
                        <label className="StripeLabel">Card Number</label>
                        {this.props.showEditable ? (
                            <>
                                <CardNumberElement
                                    options={options}
                                    onChange={(e) => {
                                        this.setCardBrand(e);
                                        this.props.onDataChanged();
                                    }}
                                />
                                <span className="card-brand">
                                    <img
                                        src={`/images/cards/${this.state.cardBrand}.svg`}
                                        alt="credit card brand logo"
                                        height={22}
                                    />
                                </span>
                            </>
                        ) : (
                            <div className="d-flex">
                                <input
                                    className="form-control"
                                    type="text"
                                    value={`•••• •••• •••• ${this.props.cardInfo.cardNumber}`}
                                    disabled={true}
                                />
                                <button
                                    type="button"
                                    className="btn btn-primary btn-edit-card"
                                    onClick={this.props.editCreditCard}
                                >
                                    Edit
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <div className="form-group row">
                    <div className="col-6">
                        <label className="StripeLabel">Exp. Date</label>
                        {this.props.showEditable ? (
                            <CardExpiryElement onChange={this.props.onDataChanged} />
                        ) : (
                            <input
                                className="form-control"
                                type="text"
                                value={`${this.props.cardInfo.expMonth}/${this.props.cardInfo.expYear}`}
                                disabled={true}
                            />
                        )}
                    </div>
                    <div className="col-6 pl-0">
                        <label className="StripeLabel">CVV</label>
                        {this.props.showEditable ? (
                            <CardCvcElement onChange={this.props.onDataChanged} />
                        ) : (
                            <input className="form-control" type="text" value="•••" disabled={true} />
                        )}
                    </div>
                </div>
                {this.props.isLoggedIn && (
                    <div className="form-group row mb-0">
                        <div className="col-12 mb-3">
                            <div className="custom-checkbox">
                                <Field
                                    name="storecard"
                                    type="checkbox"
                                    id="storecard"
                                    component={TextInput}
                                    validate={consentErrorRules}
                                />
                                <label className="form-check-label" htmlFor="storecard">
                                    Save this card for future charges
                                </label>
                            </div>
                        </div>
                    </div>
                )}
                <div className="form-group row mb-0 text-center">
                    <div className="col-12">
                        <StripeFee {...this.props.cardFee} />
                    </div>
                </div>
            </>
        );
    }
}
